import newMat from './createNewMaterials/';
import requestedMaterials from './requestedMaterials/';

export default {
  cataloger: {
    pages: {
      ...newMat,
      ...requestedMaterials,
      try: "Prueba",
    },
  },
};



// WEBPACK FOOTER //
// ./src/i18n/es-cl/cataloger/index.js